module.exports = __webpack_public_path__ + "img/techCongo.a7970e9c.png";